import AssignmentLateOutlinedIcon from "@mui/icons-material/AssignmentLateOutlined";
import ChangeCircleOutlinedIcon from "@mui/icons-material/ChangeCircleOutlined";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import PlaylistAddCheckRoundedIcon from "@mui/icons-material/PlaylistAddCheckRounded";

export const initialDashboardData = {
  summary: {
    activeOrders: 0,
    checkRequired: 0,
    changeReview: 0,
    deliveryRisk: 0,
    planPending: 0,
  },
  riskDistribution: { NORMAL: 0, ATTENTION: 0, HIGH: 0, OVERDUE: 0 },
  actionItems: [],
  weeklyDue: [],
};

export const kpiConfig = [
  { key: "activeOrders", label: "진행 주문", icon: <Inventory2OutlinedIcon />, color: "#2563eb" },
  { key: "checkRequired", label: "확인 필요", icon: <AssignmentLateOutlinedIcon />, color: "#f59e0b" },
  { key: "changeReview", label: "변경 검토", icon: <ChangeCircleOutlinedIcon />, color: "#8b5cf6" },
  { key: "deliveryRisk", label: "납기 위험", icon: <ErrorOutlineRoundedIcon />, color: "#ef4444" },
  { key: "planPending", label: "계획 미확정", icon: <PlaylistAddCheckRoundedIcon />, color: "#14b8a6" },
];

export const quickActions = [
  { title: "주문 목록", path: "orders", icon: <Inventory2OutlinedIcon />, color: "#2563eb" },
  { title: "조치 필요", path: "actions", icon: <AssignmentLateOutlinedIcon />, color: "#f59e0b" },
  { title: "변경 검토", path: "orders?status=CHANGE_REVIEW", icon: <ChangeCircleOutlinedIcon />, color: "#8b5cf6" },
  { title: "납기 위험", path: "orders?riskLevel=DELIVERY_RISK", icon: <ErrorOutlineRoundedIcon />, color: "#ef4444" },
];

export const isEmptyDashboard = (value) => {
  const summaryTotal = Object.values(value?.summary || {}).reduce(
    (sum, count) => sum + Number(count || 0),
    0
  );
  return summaryTotal === 0 && (value?.actionItems || []).length === 0;
};
